<template>
    <Head :title="translate('pricingTable.teaser:headlines').join(' ')" />

    <div class="mx-auto max-w-6xl" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('pricingTable.teaser:headlines')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-6xl sm:mx-auto sm:overflow-hidden">
                <div class="px-4 py-8 sm:px-10">
                    <p>{{ translate('order.pricingTable.body.headline') }}</p>
                </div>

                <div class="max-w-7xl mx-auto px-4 bg-white sm:px-6 lg:px-8">
                    <!-- Tiers -->
                    <div class="mt-8 space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-8">
                        <div v-for="tier in pricing" :key="tier.title" class="relative p-8 bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col">
                            <div class="flex-1">
                                <h3 class="text-xl font-semibold text-gray-900">{{ tier.title }}</h3>
                                <p v-if="tier.mostPopular" class="absolute top-0 py-1.5 px-4 bg-indigo-500 rounded-full text-sm font-semibold text-white transform -translate-y-1/2">Most popular</p>
                                <p class="mt-4 flex items-baseline text-gray-900">
                                    <span class="text-5xl tracking-tight font-bold">{{ tier.price }}</span>
                                    <span class="ml-1 text-xl font-semibold">{{ tier.frequency }}</span>
                                </p>
                                <p class="mt-6 text-gray-500">{{ tier.description }}</p>

                                <!-- Feature list -->
                                <ul role="list" class="mt-6 space-y-6">
                                    <li v-for="feature in tier.features" :key="feature" class="flex">
                                        <CheckIcon class="flex-shrink-0 w-6 h-6 text-indigo-500" aria-hidden="true" />
                                        <span class="ml-3 text-gray-500">{{ feature }}</span>
                                    </li>
                                </ul>
                            </div>

                            <a :href="tier.link" :class="[tier.mostPopular ? 'bg-indigo-500 text-white hover:bg-indigo-600' : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100', 'mt-8 block w-full py-3 px-6 border border-transparent text-center font-medium']">{{ tier.cta }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Steps :step="3"></Steps>

    </div>
</template>

<script>
import Steps from "../../../Components/Steps";
import {Head, usePage} from '@inertiajs/inertia-vue3'
import translate from "../../../../lang";
import Teaser from "../../../Components/Common/Teaser";
import { CheckIcon } from '@heroicons/vue/24/outline'

export default {
    components: {
        Teaser,
        Steps,
        Head,
        CheckIcon
    },
    props: {
        nft: Object,
        pricing: Array
    },
    created() {
    },
    setup(props) {
        return {
            translate: translate('upload-' + usePage().props.value.metaDataType.type),
        }
    }
}
</script>
